import React, { ReactNode } from 'react'

import classNames from 'classnames'

import {
  ProfileEditIcon,
  CommonShare3Icon,
  FeedCheckIcon,
  CommonHorizontalArrow7Icon,
  CommonVerifiedIcon,
} from '@local/assets/icons'

import Image from '@web/components/Image'
import { DEFAULT_PROFILE_IMAGE } from '@web/libs/constants'
import { Nullish } from '@web/types'
import Clickable from '@web/ui/components/Clickable'

import styles from './Profile.module.scss'

interface ProfileProps {
  top?: ReactNode
  isMyPage?: boolean
  isFollowing?: boolean
  nickname: string
  login?: boolean
  borderImageUrl?: Nullish<string>
  profileImageUrl?: Nullish<string>
  reviewCount?: number
  followingCount?: number
  followerCount?: number
  introduction?: Nullish<string>
  missionTitle?: Nullish<string>
  missionLeftDays?: Nullish<number>
  onClickProfile?: () => void
  onClickReview?: () => void
  onClickFollowing?: () => void
  onClickFollower?: () => void
  onClickMission?: () => void
  socialPlugin?: React.ReactNode
  foldableEllipsis?: React.ReactNode
  actionBar?: React.ReactNode
  isOfficial?: boolean
}
export default function Profile(props: ProfileProps) {
  const {
    top,
    isMyPage,
    isFollowing,
    nickname,
    login,
    onClickProfile,
    onClickReview,
    onClickFollower,
    onClickFollowing,
    onClickMission,
    borderImageUrl,
    profileImageUrl,
    reviewCount,
    followingCount,
    followerCount,
    introduction,
    missionTitle,
    missionLeftDays,
    socialPlugin,
    foldableEllipsis,
    actionBar,
    isOfficial,
  } = props

  return (
    <div className={styles.profile_area}>
      {top}
      <div className={styles.inner}>
        {login ? (
          <div className={styles.profile_wrapper}>
            {/* 프로필 이미지 영역 */}
            <div
              className={classNames(styles.profile_thumb_area, { [styles.type_following]: !isMyPage && isFollowing })}
            >
              <Clickable className={styles.thumb_area} onClick={onClickProfile}>
                <Image
                  className={styles.img}
                  src={profileImageUrl ? profileImageUrl : DEFAULT_PROFILE_IMAGE}
                  width="60"
                  height="60"
                  alt="프로필"
                />
                {borderImageUrl && (
                  <Image
                    className={styles.img_profile_border}
                    src={borderImageUrl}
                    width="88"
                    height="88"
                    alt="프로필 띠"
                  />
                )}
                {isMyPage && (
                  <span className={styles.edit}>
                    <ProfileEditIcon className={styles.icon} aria-hidden="true" />
                    <span className="place_blind">수정</span>
                  </span>
                )}
                {!isMyPage && isFollowing && (
                  <span className={styles.icon_folowing}>
                    <FeedCheckIcon className={styles.icon} aria-hidden="true" />
                    <span className="place_blind">팔로잉중</span>
                  </span>
                )}
              </Clickable>
            </div>

            {/* 프로필 정보 영역 */}
            <div className={styles.profile_info_area}>
              <div className={styles.name_area}>
                <span className={styles.name}>
                  {nickname}
                  {isOfficial && <CommonVerifiedIcon className={styles.icon_official} aria-hidden="true" />}
                </span>
              </div>
              <div className={styles.count_area}>
                <Clickable onClick={onClickReview}>
                  <span className={styles.item}>
                    리뷰 <em>{reviewCount || 0}</em>
                  </span>
                </Clickable>
                <Clickable onClick={onClickFollowing}>
                  <span className={styles.item}>
                    팔로잉 <em>{followingCount || 0}</em>
                  </span>
                </Clickable>
                <Clickable onClick={onClickFollower}>
                  <span className={styles.item}>
                    팔로워 <em>{followerCount || 0}</em>
                  </span>
                </Clickable>
              </div>
              <div className={styles.introduce_area}>{foldableEllipsis}</div>
            </div>
          </div>
        ) : (
          <div className={styles.profile_wrapper}>
            {/* 프로필 이미지 영역 */}
            <div className={styles.profile_thumb_area}>
              <Clickable className={styles.thumb_area} onClick={onClickProfile}>
                <Image className={styles.img} src={DEFAULT_PROFILE_IMAGE} width="44" height="44" alt="프로필" />
              </Clickable>
            </div>

            {/* 프로필 정보 영역 */}
            <div className={styles.profile_info_area}>
              <div className={styles.name_area}>
                <Clickable className={styles.name} onClick={onClickProfile}>
                  로그인해주세요.
                  <CommonHorizontalArrow7Icon className={styles.icon_arrow} aria-hidden="true" />
                </Clickable>
              </div>
            </div>
          </div>
        )}
        {login && isMyPage && (
          <div
            className={classNames(styles.btn_area, {
              [styles.profile_border_margin]: borderImageUrl && !introduction,
            })}
          >
            <>
              <span className={styles.btn_wrapper}>
                <Clickable className={styles.btn_mission} onClick={onClickMission}>
                  {missionLeftDays && <span className={styles.label}>{`D-${missionLeftDays}`}</span>}
                  <span className={classNames({ [styles.txt_gradient]: missionTitle })}>{missionTitle}</span>
                </Clickable>
              </span>

              {socialPlugin ? (
                socialPlugin
              ) : (
                <span className={styles.btn_wrapper}>
                  <Clickable className={styles.btn_sub}>
                    <CommonShare3Icon className={styles.icon} aria-hidden="true" />
                    <span className="place_blind">공유</span>
                  </Clickable>
                </span>
              )}
            </>
          </div>
        )}
        {login && !isMyPage && actionBar}
      </div>
    </div>
  )
}
